import { render } from "./EditProfile.vue?vue&type=template&id=a1b40262&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=a1b40262&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b40262"]])

export default __exports__